<template>
  <Section :content="moreSecure" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionMoreSecure',
  components: {
    Section,
  },
  data() {
    return {
      moreSecure: { 
        eyebrow: 'TrinPod\u2122',
        eyebrowIcon: 'trinity_secure.png',
        headline: 'More Secure Than Your Bank',
        paragraphs: [
          'When storing information and collaborating between multiple stakeholders, data security is first priority. That is why we built TrinPod\u2122 on the Solid protocols, built from the ground up to provide an extremely high level of security.',
          /*'The Solid security protocol requires a new encrypted token for every request to the server. This prevents the man-in-the-middle from getting a hold of a token and gaining access. This is more secure than your bank.'*/
        ],
        id: 'more-secure',
        image: 'trinpod-access.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        /*html: 
          '<div>' +  
          ' <h5 class="mb-4">When storing information and collaborating between multiple stakeholders, data security is first priority. That is why we built TrinPod\u2122 on the Solid protocols, built from the ground up to provide an extremely high level of security.</h5>' + 
          ' <h5 class="mb-4">The Solid security protocol requires a new encrypted token for every request to the server. This prevents the man-in-the-middle from getting a hold of a token and gaining access. This is more secure than your bank.</h5>' + 
          '</div>',*/
        learnMoreLink: '/trinpod'
      },
    }
  }
};
</script>
